import EntityAccountForm from './EntityAccountForm'

export default EntityAccountForm
